/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSegAllocCode.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/seg-alloc-code";

export class AutogenModelSegAllocCode<RowType extends ModelRow> extends Endpoint<RowType, RowSegAllocCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowSegAllocCode extends ModelRow<RowSegAllocCodeFields> {
	constructor(values?: Partial<RowSegAllocCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowSegAllocCodeFields {
	alloc_type: string;
	code: string;
	comments: string;
	company_id: string;
	descr: string;
	gl_seg_code_code1: string;
	gl_seg_code_code2: string;
	gl_seg_code_code3: string;
	gl_seg_code_code4: string;
	gl_seg_code_code5: string;
	is_active: string;
}

